module.exports = __webpack_public_path__ + "img/ape-constructor-input-shape.1489d0ed.svg";